export enum PreferenceGroupType {
    WORKER = 'worker',
    POSITION = 'position',
    CALENDAR_WEEK = 'week',
}
